export default {
    send_sms: 'auth/phone-login',
    verify_token: 'auth/verify-token',
    users: 'users',
    gas_stations: 'locations',
    cards: 'cards',
    add_balance: 'payment-transactions/add-balance',
    payment_transactions: 'payment-transactions',
    chargings: 'sessions',
    ongoing_charging: 'ongoing-session',
} as const